import { type StateCreator } from "zustand";

import { FlightTimeItem, FlightTimeState } from "./types";

const DEFAULT_INBOUND = {
  value: "inbound_any",
  label: "Any Inbound Time",
};

const DEFAULT_OUTBOUND = {
  value: "outbound_any",
  label: "Any Outbound Time",
};

const initState = {
  inbound: DEFAULT_INBOUND,
  outbound: DEFAULT_OUTBOUND,
};

export const createFlightTimesState: StateCreator<
  FlightTimeState,
  [["zustand/devtools", never]]
> = (set, get) => ({
  ...initState,

  flightTimeActions: {
    setInbound: (flightTime: FlightTimeItem) => {
      set({ inbound: flightTime });
    },
    setOutbound: (flightTime: FlightTimeItem) => {
      set({ outbound: flightTime });
    },
    resetState: () => set(initState),
  },

  flightTimeUtils: {
    generateSummaryText: () => {
      const { outbound, inbound } = get();

      if (outbound && inbound) {
        return `${outbound?.label} / ${inbound?.label}`;
      }

      return "";
    },
  },
});
